import CreditIcon from "../ui/icons/CreditIcon";
import { Text } from "../ui/text";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { UserData } from "@/types/user";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";


type Props = {
  userData: UserData;
};

const CreditBox = ({ userData }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="pl-[6px] flex flex-col gap-[5px]">
      <div className="flex gap-[6px] items-end">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="flex gap-[5px] items-center">
                <CreditIcon />
                <Text variant={"title-xl"}>{Math.trunc(userData?.availableCredit ?? 0)}</Text>
              </div>
            </TooltipTrigger>
            <TooltipContent>
              <p>{Math.trunc((userData?.availableCredit ?? 0) * 1000) / 1000} credits</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
        <Text variant={"title-sm"}>
          {userData?.availableCredit > 1
            ? t("jobPlanning.credits")
            : t("jobPlanning.credit")}{" "}
        </Text>
      </div>
      <Text variant={"label-md"} className="text-grey-50">
        {t("jobPlanning.expiresOn")}{" "}
        {dayjs(userData?.freeTrialEndDate).format("MMMM D, YYYY")}
      </Text>
    </div >
  );
};

export default CreditBox;
